export const NEXT_BTN = "Next";

export const GENERATE_BTN = "Generate";
